import * as React from "react";
import * as S from "./messageRowImprove.styled";
import { BookPlusIcon, Edit, FileOutput } from "lucide-react";
import { usePromptGeneratorContext } from "@/components/feature/promptGenerator/hooks";
import * as analytics from "@/services/analytics";
import { usePromptLibraryContext } from "@/modules/promptLibrary/promptLibrary.context";

interface Props {
  content: string;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
}

export const OpenChatMessageRowImprovementEditor: React.FC<Props> = ({ content, setIsEdit }) => {
  const { sendPromptToChat } = usePromptGeneratorContext();
  const { openCreatePromptLibraryModal } = usePromptLibraryContext();

  const handleAddToLibrary = () => {
    openCreatePromptLibraryModal(content, "open_chat");
  };

  const handleSendToChat = () => {
    sendPromptToChat(content);
    analytics.improvePromptSendToChat(content);
  };

  const handleEdit = () => {
    setIsEdit(prev => !prev);
  };

  return (
    <div className="flex justify-end">
      <S.Container
        className="ml-auto mr-1 mt-1 flex cursor-pointer rounded-md p-1 text-xs text-white"
        onClick={() => handleAddToLibrary()}
      >
        <BookPlusIcon size={12} />
        Add to library
      </S.Container>
      <S.Container className="mt-1 flex rounded-md p-1 text-xs text-white" onClick={handleSendToChat}>
        <FileOutput size={14} className="mr-1" />
        Send to chat
      </S.Container>

      <S.Container className="ml-1 mt-1 flex rounded-md p-1 text-xs text-white" onClick={handleEdit}>
        <Edit size={14} className="mr-1" />
        Edit
      </S.Container>
    </div>
  );
};
